var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"show-header":"","border":false,"no-data-text":_vm.$t('basic.tip.noReports'),"columns":_vm.report.columns,"data":_vm.report.data}})}
var staticRenderFns = []

export { render, staticRenderFns }